'use client';

import { TTL_IN_SECONDS } from '../../../../../constants';

export const SET_INITIAL_COOKIE = TTL_IN_SECONDS.FIVE_MINUTES * 1000;
export const SET_RENEWAL_COOKIE = TTL_IN_SECONDS.TWO_MINUTES * 1000;

export const setHandoverSessionCookie = (renew: boolean = false) => {
  if (typeof window !== 'undefined') {
    const exp = Date.now() + (renew ? SET_RENEWAL_COOKIE : SET_INITIAL_COOKIE);

    sessionStorage.setItem(
      'handover',
      JSON.stringify({
        status: 'active',
        expires: exp.toString()
      })
    );
  }

  setTimeout(
    () => {
      clearHandoverSessionCookie();
    },
    renew ? SET_RENEWAL_COOKIE : SET_INITIAL_COOKIE
  );
};

export const hasHandoverSessionCookie = (): boolean => {
  if (typeof window !== 'undefined') {
    const existingHandover = sessionStorage.getItem('handover');
    if (existingHandover) {
      try {
        const handover = JSON.parse(existingHandover);
        if (handover.status === 'active' && Number(handover.expires) > Date.now()) {
          return true;
        } else if (Number(handover.expires) <= Date.now()) {
          clearHandoverSessionCookie();
        }
      } catch (error) {
        clearHandoverSessionCookie();
      }
    }
  }
  return false;
};

export const renewHandoverSessionCookie = () => {
  if (typeof window !== 'undefined') {
    const existingHandover = sessionStorage.getItem('handover');

    if (!existingHandover) {
      setHandoverSessionCookie(true);
      return;
    }

    try {
      const handover = JSON.parse(existingHandover);
      const exp = Number(handover.expires) + SET_RENEWAL_COOKIE;

      sessionStorage.setItem(
        'handover',
        JSON.stringify({
          status: 'active',
          expires: exp.toString()
        })
      );
    } catch (error) {
      setHandoverSessionCookie(true);
      return;
    }
  }
};

export const clearHandoverSessionCookie = () => {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem('handover');
    removeQueryParam('bho');
  }
};

export const removeQueryParam = (param: string) => {
  const url = new URL(window.location.href);
  if (url.searchParams.has(param)) {
    url.searchParams.delete(param);
    window.history.replaceState({}, '', url.toString());
  }
};
